// const test = {
// 	letter1Digits2: {
// 		func: (string = "") => !string ? true : string.match(/^[a-zA-Z]\d{1,2}$/g),
// 		msg: "Bogstav + max 2 cifre (fx M12)"
// 	},
// 	digits5: {
// 		func: (string = "") => !string ? true : string.match(/^\d{1,5}$/g),
// 		msg: "Max 5 cifre"
// 	},
// 	digits: {
// 		func: (string = "") => !string ? true : string.match(/^[0-9]*$/g),
// 		msg: "Cifre"
// 	},
// 	digitsComma: {
// 		func: (string = "") => !string ? true : string.match(/^\d+(,\d+)?$/g),
// 		msg: "Cifre med mulighed for komma"
// 	}
// };

export default () => ({
	basic: {
		name: "Generelt",
		id: "basic",
		active: true,
		fields: [
			{
				name: "Forhandler",
				props: {
					type: "input",
					disabled: true,
				},
			},
			{
				name: "Erhvervsordre",
				props: {
					type: "checkbox",
					label:
            "Dette er en erhvervsordre. Der afviges fra EN13120 (ikke børnesikker)",
				},
			},
			{
				name: "Dato",
				props: {
					type: "date",
					disabled: true,
				},
			},
			{
				name: "Ønsket afsendelsesdato",
				props: {
					type: "date",
				},
			},
			{
				name: "Solgt af",
				props: {
					type: "input",
				},
			},
			{
				name: "Mærkning",
				props: {
					type: "input",
				},
			},
		],
	},

	sections: [
		{
			name: "Plissé og Dupli",
			fields: [
				{
					name: "Model",
					required: true,
					tooltip: {
						text: `Ved elektriske modeller skal du angive motor- og betjeningstype samt strømkilde i bemærkningsfeltet.`,
					},
					props: {
						type: "input",
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Plissébredde",
					required: true,
					props: {
						type: "select",
						options: [
							"20 mm plissé",
							"32 mm plissé",
							"25 mm Dupli",
							"32 mm Dupli",
							"64 mm Dupli",
						],
					},
				},
				{
					name: "Mål (mm)",
					tooltip: {
						text: `Angiv færdigmål ved lige modeller. Hvis du vælger murmål ved lige modeller, fratrækker vi 0,5 cm i bredden.`,
						img: require("!file-loader!@/assets/order/drawing1.svg"),
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde (A)",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde (C)",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Bredde (B)",
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde (D)",
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Opmåling",
					required: true,
					tooltip: {
						text: `Ved skrå modeller og sidelister skal du altid angive murmålene.`,
					},
					props: {
						type: "select",
						options: ["Færdigmål", "Murmål"],
					},
				},
				{
					name: "Listefarve",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"Hvid",
							"Sølv",
							"Antracit",
							"Sort",
							"Beige",
							"Børstet aluminium natur",
							"Børstet aluminium champagne",
						],
					},
				},
				{
					name: "Betjeningsside",
					props: {
						type: "select",
						options: ["Ingen", "Venstre", "Højre"],
					},
				},
				{
					name: "Betjeningslængde",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "input",
					},
				},
				{
					name: "Greb",
					tooltip: {
						text: `Almindelige modeller med greb leveres som standard med metalgreb. Cordless modellerne leveres som standard uden greb. PB modellerne leveres udelukkende med plastgreb.`,
					},
					props: {
						type: "select",
						options: ["Ingen", "Standard (se infoboks)", "Plast", "Metal"],
					},
				},
				{
					name: "Montering",
					required: true,
					props: {
						type: "select",
						options: [
							"Loft",
							"Væg",
							"Sidelister L-profil",
							"Sidelister U-profil",
							"LightBlock L-profil",
							"LightBlock U-profil",
							"Quickfit loft - hvid",
							"Quickfit loft - grå",
							"Quickfit væg - hvid",
							"Quickfit væg - grå",
						],
					},
				},
				{
					name: "Kiler",
					props: {
						type: "select",
						options: ["Ingen", "14 grader", "21 grader"],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Rullegardiner",
			fields: [
				{
					name: "Model",
					required: true,
					tooltip: {
						text: `Hvis bredden på et rullegardin kræver et større rør, vil alle gardiner på ordren som standard blive placeret på samme størrelse system, medmindre du angiver andet i bemærkningsfeltet. Angiver du "murmål i bemærkningsfeltet, fratrækkes 0,5 cm i bredde`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"Small",
							"Medium",
							"Large",
							"CS",
							"CS med sidelister",
							"CM",
							"CM med sidelister",
							"CL",
							"CL med sidelister",
							"K4",
							"SC",
							"DHR",
							"DHS",
						],
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Oprul",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: ["Standard", "Omvendt"],
					},
				},
				{
					name: "Færdigmål (mm)",
					tooltip: {
						text: `Ved stofmål eller murmål, bedes du angive dette i bemærkningsfeltet`,
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Systemfarve",
					tooltip: {
						text: `Cordless, Quickfit, K1, K2, K3 fås i hvid og sølv Montageprofil fås i hvid, sølv og beige Frontprofil fås i hvid, sølv og sort`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"Hvid",
							"Sølv",
							"Sort",
							"Off-white",
							"Børstet alu",
							"Børstet champagne",
						],
					},
				},
				{
					name: "Komponentfarver",
					tooltip: {
						text: `Hvis anden en standard`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"Hvid",
							"Off-white",
							"Grå",
							"Antracit",
							"Sort",
							"Brun",
							"Hvid stålkæde",
							"Sølv stålkæde",
							"Sort stålkæde",
						],
					},
				},
				{
					name: "Beslag og dækkapper",
					tooltip: {
						text: `Leveres som standard med Quick mount, medmindre du vælger andet`,
					},
					props: {
						type: "select",
						options: ["Standard", "Designbeslag", "Luksus dækkappe"],
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Angiv eventuel strømkilde og betjening i bemærkningsfeltet ved elektrisk betjening`,
					},
					props: {
						type: "select",
						options: [
							"Kæde",
							"Fjeder",
							"Cordless",
							"Elektrisk 12 V RTS",
							"Roll up 28 RTS Li-Ion 12 V",
							"Sonesse 30 ULTRA RTS Li-Ion 12 V",
							"Elektrisk 24 V RTS",
							"Elektrisk 24 V Kontakt",
							"Elektrisk 230 V RTS",
							"Elektrisk 230 V kontakt",
							"Elektrisk 230 V io",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: ["Ingen", "Venstre", "Højre"],
					},
				},
				{
					name: "Betjeningslængde",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "input",
					},
				},
				{
					name: "Montering",
					props: {
						type: "select",
						options: ["Standard", "Loft", "Væg"],
					},
				},
				{
					name: "Øvrige montageløsninger",
					props: {
						type: "select",
						options: [
							"Ingen",
							"Wirestyr",
							"Wirestyr Plus",
							"Quickfit",
							"Montageprofil",
						],
					},
				},
				{
					name: "Bundliste",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"DS 1 (hvid, D-formet)",
							"DS 2 (sølv, D-formet)",
							"DS 3 (antracit, D-formet)",
							"DS 4 (off-white, D-formet)",
							"DS 5 (sort, D-formet)",
							"DS 6 (brun, D-formet)",
							"OS 1 (hvid, rund)",
							"OS 2 (sølv, rund)",
							"OS 5 (sort, rund)",
							"HL1 (hvid)",
							"HL2 (hvid træstruktur)",
							"HL4 (træ)",
							"HL5 (sort)",
							"HL6 (kold ler)",
							"HL7 (grå træ)",
							"HL8 (antracit)",
							"HL9 (taupe)",
							"HL10 (mørk træ)",
							"HL11 (natur træ)",
							"HL12 (bambus)",
							"KH 1 (hvid, nøglehul)",
							"KH 2 (sølv, nøglehul)",
							"KH 5 (sort, nøglehul)",
							"SQ 1 (hvid, rektangulær)",
							"SQ 4 (off-white, rektangulær)",
							"SQ 7 (børstet alu, rektangulær)",
							"SQ 8 (børstet champagne, rektangulær)",
							"SQ 9 (børstet sort, rektangulær)",
						],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Duo Rollers",
			fields: [
				{
					name: "Model",
					required: true,
					props: {
						type: "select",
						options: [
							"Monteringsprofil",
							"Rund kassette",
							"Firkantet kassette",
						],
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Færdigmål (mm)",
					tooltip: {
						text: `Ved murmål, bedes du angive dette i bemærkningsfeltet`,
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Systemfarve",
					tooltip: {
						text: `Hvis anden en standard`,
					},
					props: {
						type: "select",
						options: ["Standard", "Hvid", "Sølv", "Champagne", "Sort", "Beige"],
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Angiv eventuel strømkilde og betjening i bemærkningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Kædetræk",
							"Elektrisk 12 V RTS",
							"Roll up 28 RTS Li-Ion 12 V",
							"Sonesse 30 ULTRA RTS Li-Ion 12 V",
							"Elektrisk 24 V RTS",
							"Elektrisk 24 V Kontakt",
							"Elektrisk 230 V RTS",
							"Elektrisk 230 V Kontakt",
							"Elektrisk 230 V io",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: ["Venstre", "Højre"],
					},
				},
				{
					name: "Betjeningslængde",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"50 cm",
							"75 cm",
							"100 cm",
							"125 cm",
							"150 cm",
							"175 cm",
							"200 cm",
						],
					},
				},
				{
					name: "Montering",
					tooltip: {
						text: `Skal opgives ved monteringsprofil`,
					},
					props: {
						type: "select",
						options: [
							"Standard",
							"Loft",
							"Væg",
							"Quickfit hvid",
							"Quickfit grå",
						],
					},
				},
				{
					name: "Monteringstilvalg",
					props: {
						type: "select",
						options: [
							"Ingen",
							"Plastvinduesbeslag",
							"Wirestyr",
							"Plastvinduesbeslag med wirestyr",
							"Forskydeligt beslag",
						],
					},
				},
				{
					name: "Bundliste",
					tooltip: {
						text: `Hvis anden end standard. Duo Rollers med wirestyr leveres udelukkende med lukket bundliste`,
					},
					props: {
						type: "select",
						options: ["Standard", "Lukket", "Rund"],
					},
				},
				{
					name: "Sæt",
					tooltip: {
						text: `Hvis "ja", angiv da i bemærkningsfeltet, hvilket gardin der er styrende i sættet, så de øvrige gardiners striber følger striberne i det styrende gardin.`,
					},
					props: {
						type: "select",
						options: ["Ja", "Nej"],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Lamelgardiner",
			fields: [
				{
					name: "Model",
					required: true,
					props: {
						type: "select",
						options: [
							"Model 1 – Lige",
							"Model 2 – Vindue/dør",
							"Model 5 - Skrå foroven",
							"Model 11 – Skrå forneden",
						],
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Lamelbredde",
					required: true,
					props: {
						type: "select",
						options: ["63 mm", "89 mm", "127 mm"],
					},
				},
				{
					name: "Mål (mm)",
					tooltip: {
						text: `Angiv færdigmål ved lige modeller. Hvis du vælger murmål ved lige modeller, fratrækker vi 0,5 cm i bredden og 2 cm. i højden. Ved skrå systemer opgiv altid stramt mål. Hvis intet andet opgives, fratrækkes 1,5 cm. i højden.`,
						img: require("!file-loader!@/assets/order/drawing1.svg"),
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde (A)",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Bredde (B)",
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde (C)",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde (D)",
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Opmåling",
					required: true,
					props: {
						type: "select",
						options: ["Færdigmål", "Murmål"],
					},
				},
				{
					name: "Listefarve",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: ["Standard", "Hvid", "Sølv", "Sort"],
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Ved elektrisk betjening skal du angive betjeningstype i bemærkningsfeltet.`,
					},
					props: {
						type: "select",
						options: [
							"Snor/kæde",
							"Fører-/drejestang",
							"Mono command",
							"Elektrisk 230 V RTS",
							"Elektrisk 230 V kontakt",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: ["Venstre", "Højre"],
					},
				},
				{
					name: "Betjeningslængde",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "input",
					},
				},
				{
					name: "Betjeningsfarve",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: ["Standard", "Hvid", "Grå", "Sort", "Metal"],
					},
				},
				{
					name: "Bundvægt/bundkæde",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: ["Standard", "Hvid", "Sort", "Metal", "Indsvejst"],
					},
				},
				{
					name: "Parkering",
					required: true,
					props: {
						type: "select",
						options: [
							"1 - Højre",
							"2 - Venstre",
							"3 - Midtåbning",
							"4 - Midtlukning",
						],
					},
				},
				{
					name: "Montering",
					required: true,
					tooltip: {
						text: `Vægbeslagene er ikke medregnet i gardinets færdighøjde`,
					},
					props: {
						type: "select",
						options: ["Loft", "Væg"],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Alupersienner",
			fields: [
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Lamelbredde",
					required: true,
					props: {
						type: "select",
						options: ["16 mm", "25 mm", "35 mm", "50 mm"],
					},
				},
				{
					name: "Færdigmål (mm)",
					tooltip: {
						text: `Hvis du opgiver "murmål" i bemærkningsfeltet, fratrækkes 0,5 cm i bredden og 0,5 cm i højden`,
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Angiv eventuel strømkilde og betjening i bemærkningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Optrækssnor",
							"Kædetræk",
							"Cordless",
							"12 V RTS-motor",
							"24 V motor kontakt",
							"230 V RTS-motor",
							"230 V motor kontakt",
						],
					},
				},
				{
					name: "Betjeningsside",
					props: {
						type: "select",
						options: [
							"...",
							"Venstre",
							"Højre",
							"Opdelt (optræk V / vippe H)",
							"Opdelt (optræk H / vippe V)",
						],
					},
				},
				{
					name: "Betjeningslængde",
					tooltip: {
						text: `Ved kædetræk, kædelængder: 50, 75, 100, 125, 150, 175, 200, 225 og 250 cm.`,
					},
					props: {
						type: "input",
					},
				},
				{
					name: "Kædetrækfarve",
					tooltip: {
						text: `Hvis anden end standard`,
					},
					props: {
						type: "select",
						options: ["Standard", "Hvid", "Grå", "Beige", "Sort", "Metal"],
					},
				},
				{
					name: "Cordless grebfarve (25 mm)",
					props: {
						type: "select",
						options: ["...", "Hvid", "Grå", "Sort"],
					},
				},
				{
					name: "Montering",
					tooltip: {
						text: `Påkrævet ved bestilling af Cordless og bestilling af wirestyr`,
					},
					props: {
						type: "select",
						options: ["Standard", "Niche", "Væg (frontmonteret)"],
					},
				},
				{
					name: "Monteringstilvalg",
					props: {
						type: "select",
						options: [
							"Ingen",
							"Plastvinduebeslag",
							"Wirestyr",
							"Hold down beslag",
							"Lange beslag",
						],
					},
				},
				{
					name: "Tilvalg",
					props: {
						type: "group",
						fields: [
							{
								name: "10 mm stigebånd",
								tooltip: {
									text: "Tilgængeligt til 25 og 50 mm"
								},
								props: {
									type: "input"
								}
							},
							{
								name: "25 mm stigebånd",
								tooltip: {
									text: `Tilgængeligt til 50 mm`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "38 mm stigebånd",
								tooltip: {
									text: `Tilgængeligt til 50 mm`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "Øvrige systemer",
								props: {
									type: "select",
									options: ["...", "Fri parkering (16 og 25 mm)", "MegaView® (25 mm)", "Privacy"],
								},
							},
							{
								name: "Farvemodeller",
								props: {
									type: "select",
									options: [
										"Ingen",
										"Border (80/20)",
										"Mix",
									],
								},
							},
						],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Træpersienner",
			fields: [
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Lamelbredde",
					required: true,
					props: {
						type: "select",
						options: ["25 mm", "50 mm", "65 mm"],
					},
				},
				{
					name: "Færdigmål (mm)",
					tooltip: {
						text: `Hvis du opgiver "murmål" i bemærkningsfeltet, fratrækker vi 0,5 cm i bredden og 0,5 cm i højden`,
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Betjening",
					required: true,
					props: {
						type: "select",
						options: [
							"Optrækssnor",
							"Elektrisk 230 V RTS-motor (50 og 65 mm)",
							"230 V motor kontakt (50 og 65 mm)",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: [
							"Venstre",
							"Højre",
							"Opdelt (optræk V / vippe H)",
							"Opdelt (optræk H / vippe V)",
						],
					},
				},
				{
					name: "Betjeningslængde",
					props: {
						type: "input",
						unit: "mm",
					},
				},
				{
					name: "Montering",
					required: true,
					props: {
						type: "select",
						options: [
							"Niche (frontprofil uden gavle)",
							"Væg (frontprofil med gavle)",
						],
					},
				},
				{
					name: "Monteringstilvalg",
					props: {
						type: "select",
						options: ["Ingen", "Wirestyr", "Hold down beslag (25 og 50 mm)", "Lange beslag (25 mm)"],
					},
				},
				{
					name: "Dekorative tilvalg",
					props: {
						type: "group",
						fields: [
							{
								name: "10 mm stigebånd",
								tooltip: {
									text: "Tilgængeligt til 50 mm",
								},
								props: {
									type: "input",
								},
							},
							{
								name: "25 mm stigebånd",
								tooltip: {
									text: `Tilgængeligt til 50 mm`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "38 mm stigebånd",
								tooltip: {
									text: `Tilgængeligt til 50 og 65 mm`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "Farvemodeller",
								props: {
									type: "select",
									options: [
										"Ingen",
										"Border (80/20)",
										"Mix",
									],
								},
							},
						],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Butterfly",
			fields: [
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Dessin",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Færdigmål (mm)",
					tooltip: {
						text: `Hvis du opgiver "murmål" i bemærkningsfeltet, fratrækkes 0,5 cm i bredden og 0,5 cm i højden`,
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Højde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Monteringshøjde",
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Betjening",
					required: true,
					props: {
						type: "select",
						options: ["Optrækssnor/vippesnor", "Optrækskæde/vippesnor"],
					},
				},
				{
					name: "Betjeningsside",
					props: {
						type: "group",
						fields: [
							{
								name: "Optrækssnor/kæde",
								required: true,
								props: {
									type: "select",
									options: ["Venstre", "Højre"],
								},
							},
							{
								name: "Vippesnor",
								required: true,
								props: {
									type: "select",
									options: ["Venstre", "Højre"],
								},
							},
						],
					},
				},
				{
					name: "Betjeningslængde",
					tooltip: {
						text: `Hvis anden end standard. Valgfrit ved optrækssnor Std. størrelser ved kædetræk (se tekniske sider)`,
					},
					props: {
						type: "input",
						unit: "mm",
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Markiser",
			fields: [
				{
					name: "Model",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Færdigmål (mm)",
					tooltip: {
						text: `Armene kan maks. flyttes 40 cm ind når markisens bredde tillader det. Samt armene kan min. flyttes 10 cm ind.`,
					},
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Udfald",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Stelfarve",
					required: true,
					tooltip: {
						text: `Bemærk! Se venligst prislisten for standard farver på den valgte model. Monaco fås kun som standard grå; mod tillæg for hvid.
Angiv eventuel speciel RAL-farve i bemærkningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Hvid",
							"RAL 9001 Creme",
							"RAL 7016 Antracit struktur",
							"RAL 8019 Brun",
							"Anodiseret",
							"Grå lak (Monaco)",
							"Speciel RAL-farve",
						],
					},
				},
				{
					name: "Dug",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Tunge",
					tooltip: {
						text: `Påkrævet ved bestilling af Monaco`,
					},
					props: {
						type: "select",
						options: ["Ingen", "Lige kant", "Bølget kant"],
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Angiv betjeningstypen ved RTS/IO i fjernbetjeningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Drejestang",
							"Motor med kontakt",
							"Motor med RTS (ekskl. fjernbetjening)",
							"Motor med IO (ekskl. fjernbetjening)",
							"Ingen",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: ["Venstre", "Højre"],
					},
				},
				{
					name: "Drejestang længde (cm)",
					props: {
						type: "select",
						options: [
							"Standard",
							"140 cm",
							"160 cm",
							"180 cm",
							"200 cm",
							"Anden",
						],
					},
				},
				{
					name: "Beslag",
					required: true,
					props: {
						type: "select",
						options: ["Væg", "Loft"],
					},
				},
				{
					name: "Styring",
					props: {
						type: "group",
						fields: [
							{
								name: "Fjernbetjening",
								props: {
									type: "input",
								},
							},
							{
								name: "Vindsensor",
								props: {
									type: "input",
								},
							},
							{
								name: "Solsensor",
								tooltip: {
									text: `Skal altid kombineres med vindsensor`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "Sol- og vindsensor",
								props: {
									type: "input",
								},
							},
						],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Vinduesmarkiser",
			fields: [
				{
					name: "Model",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Færdigmål (mm)",
					props: {
						type: "group",
						fields: [
							{
								name: "Hældning",
								required: true,
								props: {
									type: "select",
									options: ["90°", "135°", "90° - 135° (S2000)"],
								},
							},
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Udfald",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Stelfarve",
					required: true,
					tooltip: {
						text: `Bemærk! Se venligst prislisten for standard farver på den valgte model. S2000 fås kun som standard grå; mod tillæg for hvid.
Angiv eventuel speciel RAL-farve i bemærkningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Hvid",
							"RAL 9001 Creme",
							"RAL 7016 Antracit struktur",
							"RAL 8019 Brun",
							"Anodiseret",
							"Grå lak (S2000)",
							"Speciel RAL-farve",
						],
					},
				},
				{
					name: "Dug",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Tunge",
					tooltip: {
						text: `Påkrævet ved bestilling af S2000`,
					},
					props: {
						type: "select",
						options: ["Ingen", "Lige kant", "Bølget kant"],
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Angiv betjeningstypen ved RTS/IO i fjernbetjeningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Udvendigt gear/drejestang",
							"Indvendigt gear/drejestang",
							"Motor med kontakt",
							"Motor med RTS (ekskl. fjernbetjening)",
							"Motor med IO (ekskl. fjernbetjening)",
							"Ingen",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: ["Venstre", "Højre"],
					},
				},
				{
					name: "Betjeningsudgang",
					tooltip: {
						text: `Bemærk! Se venligst prislisten for betjeningsudgangs mulighederne på den valgte model.`,
					},
					required: true,
					props: {
						type: "select",
						options: [
							"A - Gear udgang",
							"C - Bagside kassette top",
							"D - Bagside kassette midt",
							"E - Top bagest kassette",
							"F - Top forrest kassette",
							"G - Bagside kassette nederst",
						],
					},
				},
				{
					name: "Drejestang længde (cm)",
					props: {
						type: "select",
						options: ["140 cm", "160 cm", "180 cm", "200 cm", "Anden"],
					},
				},
				{
					name: "Beslag",
					required: true,
					props: {
						type: "select",
						options: ["Væg", "Loft", "Niche"],
					},
				},
				{
					name: "Styring",
					props: {
						type: "group",
						fields: [
							{
								name: "Fjernbetjening",
								props: {
									type: "input",
								},
							},
							{
								name: "Vindsensor",
								props: {
									type: "input",
								},
							},
							{
								name: "Solsensor",
								tooltip: {
									text: `Skal altid kombineres med vindsensor`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "Sol- og vindsensor",
								props: {
									type: "input",
								},
							},
						],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
		{
			name: "Screens",
			fields: [
				{
					name: "Model",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Zip/Standard",
					required: true,
					props: {
						type: "select",
						options: ["Zip", "Standard"],
					},
				},
				{
					name: "Kassette type",
					required: true,
					props: {
						type: "select",
						options: ["Firkantet", "Afrundet", "Anden"],
					},
				},
				{
					name: "Antal",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Færdigmål (mm)",
					props: {
						type: "group",
						fields: [
							{
								name: "Bredde",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
							{
								name: "Udfald",
								required: true,
								props: {
									type: "input",
									unit: "mm",
								},
							},
						],
					},
				},
				{
					name: "Stelfarve",
					required: true,
					tooltip: {
						text: `Bemærk! Se venligst prislisten for standard farver på den valgte model.
Angiv eventuel speciel RAL-farve i bemærkningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Hvid",
							"RAL 9001 Creme",
							"RAL 7016 Antracit struktur",
							"RAL 7016 Antracit",
							"RAL 8019 Brun",
							"Speciel RAL-farve",
						],
					},
				},
				{
					name: "Dug",
					required: true,
					props: {
						type: "input",
					},
				},
				{
					name: "Betjening",
					required: true,
					tooltip: {
						text: `Angiv betjeningstypen ved RTS/IO i fjernbetjeningsfeltet`,
					},
					props: {
						type: "select",
						options: [
							"Udvendigt gear/drejestang",
							"Indvendigt gear/drejestang",
							"Motor med kontakt",
							"Motor med RTS (ekskl. fjernbetjening)",
							"Motor med IO (ekskl. fjernbetjening)",
							"Ingen",
						],
					},
				},
				{
					name: "Betjeningsside",
					required: true,
					props: {
						type: "select",
						options: ["Venstre", "Højre"],
					},
				},
				{
					name: "Betjeningsudgang",
					tooltip: {
						text: `Bemærk! Se venligst prislisten for betjeningsudgangs mulighederne på den valgte model.`,
					},
					required: true,
					props: {
						type: "select",
						options: [
							"A - Gear udgang",
							"C - Bagside kassette top",
							"D - Bagside kassette midt",
							"E - Top bagest kassette",
							"F - Top forrest kassette",
							"G - Bagside kassette nederst (ikke muligt ved motor)",
							"R - Motorkabel bagside sidelister",
							"Z - I siden af kassetten",
						],
					},
				},
				{
					name: "Drejestang længde (cm)",
					props: {
						type: "select",
						options: ["140 cm", "160 cm", "180 cm", "200 cm", "Anden"],
					},
				},
				{
					name: "Beslag",
					required: true,
					props: {
						type: "select",
						options: ["Væg", "Loft", "Niche"],
					},
				},
				{
					name: "Styring",
					props: {
						type: "group",
						fields: [
							{
								name: "Fjernbetjening",
								props: {
									type: "input",
								},
							},
							{
								name: "Vindsensor",
								props: {
									type: "input",
								},
							},
							{
								name: "Solsensor",
								tooltip: {
									text: `Skal altid kombineres med vindsensor`,
								},
								props: {
									type: "input",
								},
							},
							{
								name: "Sol- og vindsensor",
								props: {
									type: "input",
								},
							},
						],
					},
				},
				{
					name: "Bemærkninger",
					props: {
						type: "textarea",
					},
				},
			],
		},
	],
});
